<template>
  <v-checkbox
    v-model="withoutPredictions"
    hide-details
    label="Obtener items que no tienen predicciones para la clasificación"
  />
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("classifier");

export default {
  computed: {
    ...mapState(["showItemsWithoutPredictions"]),
    withoutPredictions: {
      get() {
        return this.showItemsWithoutPredictions;
      },
      set(value) {
        this.setShowItemsWithoutPredictions(value);
      }
    }
  },
  methods: {
    ...mapMutations(["setShowItemsWithoutPredictions"])
  }
};
</script>